import { formatBalance, formatMoney } from '@aquabox/shared';

/**
 * Cari bakiye hücresi — müşteri ekstresiyle AYNI dili konuşur: "₺136,50 B" (borç),
 * "₺25,00 A" (alacak), "₺0,00" (ek yok).
 *
 * Bu bileşen cari bakiyeyi gösteren TEK yer: `Cash.tsx` (Cari sekmesi) ve
 * `Customers.tsx` (müşteri listesi + müşteri kartı) aynı yardımcıyı kullanır.
 *
 * YÖN ham string'in başındaki '-' işaretinden okunur — i18n metnine BAĞLI DEĞİLDİR;
 * ek yazısı (`statement.balanceSuffix.*`) değişse de renk değişmez. PARA HESABI YAPILMAZ
 * (kural 4): değer sunucunun verdiği Decimal string'idir, yalnızca biçimlenir.
 */
export function balanceCell(balance: string): { text: string; color: string; debtor: boolean } {
  const raw = typeof balance === 'string' ? balance.trim() : '';
  const negative = raw.startsWith('-');
  const abs = negative ? raw.slice(1) : raw;
  const text = formatBalance(raw);
  // Sıfır bakiye ek basmaz ve nötr renktedir. Sıfırlık BİÇİMLENMİŞ parayla karşılaştırılır
  // (hesap değil, aynı sunucu string'inin gösterim karşılaştırması) — böylece "0.001"
  // gibi sıfıra yuvarlanan değer de ek basmadan nötr kalır.
  const zero = formatMoney(abs === '' ? '0' : abs) === formatMoney('0');
  if (zero) return { text, color: 'var(--text-primary)', debtor: false };
  // Negatif = müşterinin alacağı (yeşil), pozitif = müşteri borçlu (kırmızı).
  if (negative) return { text, color: 'var(--success)', debtor: false };
  return { text, color: 'var(--danger)', debtor: true };
}

/**
 * Bakiye hücresi bileşeni. `fontSize` verilmezse tablo satırının gövde yazı tipi
 * kullanılır (Cash tablosu); verilirse liste satırının tipi (müşteri listesi).
 */
export function BalanceCell({ balance, fontSize }: { balance: string; fontSize?: number }) {
  const { text, color } = balanceCell(balance);
  return (
    <span
      style={{
        textAlign: 'right',
        fontWeight: 600,
        ...(fontSize === undefined ? {} : { fontSize }),
        color,
      }}
    >
      {text}
    </span>
  );
}
